var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feLogout0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feLogout1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "feLogout2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2.5C0.5 1.4 1.4 0.5 2.5 0.5H10.5V2.5H2.5V16.5H10.5V18.5H2.5C1.4 18.5 0.5 17.6 0.5 16.5V2.5ZM14.676 8.5L12.14 5.964L13.554 4.55L18.504 9.5L13.554 14.45L12.14 13.036L14.676 10.5H8.09V8.5H14.676Z",
    fill: "#F5F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ce563c5b40bb47447d8d0007986c75b6.svg";
export { ForwardRef as ReactComponent };